import * as React from 'react';
import cx from 'clsx';
import { ArrowDownIcon, CheckIcon } from '@heroicons/react/solid';
import { Icon } from '@vechaiui/react';
import { Listbox, Transition } from '@headlessui/react';
import { useLocalization } from '@fluent/react';

import { OrderStatus } from '#/__generated__/graphql/graphql';

const OrderStatusListBox: React.FC<OrderStatusListBoxProps> = ({ exclusions, value, onChange }) => {
  const { l10n } = useLocalization();
  let orderStatuses = Object.values(OrderStatus);
  if (exclusions) {
    orderStatuses = orderStatuses.filter((status) => !exclusions.includes(status));
  }

  return (
    <div>
      <Listbox value={value ?? []} onChange={onChange} multiple>
        <Listbox.Button>
          <div className="p-1">
            {l10n.getString('filter-by-status')}
            <Icon as={ArrowDownIcon} className="w-4 text-gray-500 ml-2" label="selector" />
          </div>
        </Listbox.Button>
        <Transition
          enter="transition duration-100 ease-out"
          enterFrom="transform scale-95 opacity-0"
          enterTo="transform scale-100 opacity-100"
          leave="transition duration-75 ease-out"
          leaveFrom="transform scale-100 opacity-100"
          leaveTo="transform scale-95 opacity-0"
        >
          <Listbox.Options
            className={cx(
              'absolute left-0 z-dropdown w-56 min-w-max mt-2 origin-top-left rounded-md shadow-sm outline-none',
              'bg-white border border-gray-200',
              'dark:bg-neutral-800 dark:border-gray-700',
            )}
          >
            <div className="px-1 py-1">
              {orderStatuses.map((value) => {
                return (
                  <Listbox.Option key={value.toString()} value={value} as={React.Fragment}>
                    {({ active, selected }) => (
                      <li
                        className={cx(active ? 'bg-primary-500 text-white' : 'bg-white text-black')}
                      >
                        <Icon
                          as={CheckIcon}
                          className={cx(
                            'w-4 ml-2 mr-2',
                            selected ? 'text-green-500' : 'text-whiteAlpha-50',
                          )}
                          label="selector"
                        />
                        {l10n.getString(value)}
                      </li>
                    )}
                  </Listbox.Option>
                );
              })}
            </div>
          </Listbox.Options>
        </Transition>
      </Listbox>
    </div>
  );
};
export type OrderStatusListBoxProps = {
  exclusions?: OrderStatus[];
  onChange: (value: OrderStatus[]) => void;
  value?: OrderStatus[];
};

export default OrderStatusListBox;
